import { useGetDividendsPerYear } from "@bn/api/apiv1";

export const useDividendsPerYearForInvestment = (investmentId?: number) => {
  const query = useGetDividendsPerYear(
    { investmentId, predictNumberOfYears: 2 },
    {
      enabled: !!investmentId,
    }
  );

  return { ...query, data: query.data?.dividendsPerYear };
};
